import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MenuitemsService {

  constructor(private  httpClient: HttpClient) {
  }

  saveGeneralSetting(items) {
    return this.httpClient.post('/dashboard/generalsetting/', items);
  }

  getGeneralSettings() {
    return this.httpClient.get('/dashboard/generalsetting/');
  }

  getMobileAppSettings() {
    return this.httpClient.get('/dashboard/mobileappsettings/');
  }

  saveMobileSetting(items) {
    return this.httpClient.post('/dashboard/mobileappsettings/', items);
  }
  getMobileSetting() {
    return this.httpClient.get('/dashboard/getmobileappsettings/');
  }
  
  logoUpload(image){
    return this.httpClient.post('/dashboard/logoupload/',image);

  }
  getLogo(){
    return this.httpClient.get('/dashboard/logoupload/');

  }
  faviconUpload(favicon){
    return this.httpClient.post('/dashboard/faviconupload/',favicon); 

  }
  getfavicon(){
    return this.httpClient.get('/dashboard/faviconupload/');

  }
  getLogoLogin(){
    return this.httpClient.get('/dashboard/logouploadLogin/');

  }
  saveMobAppOptional(app_optional) {
    return this.httpClient.post('/dashboard/mobileappoptionalsettings/', app_optional);
  }
  sendAdminMessage(message){
    return this.httpClient.post('/dashboard/send_admins_message/', message);
  }
  DeleteMobileSetting(){
    return this.httpClient.get('/dashboard/delete_mobileapp_settings/');
  }
  
  // getMenuitems() {
  //   return this.httpClient.get('/dashboard/menuitems/');
  // }
  // getMenuitem(id) {
  //   return this.httpClient.get(`/dashboard/menuitems/${id}/`);
  // }
  // postMenuitem(menuitem) {
  //   return this.httpClient.post('/dashboard/menuitems/', menuitem);
  // }
  // updateMenuitem(id, menuitem) {
  //   return this.httpClient.patch(`/dashboard/menuitems/${id}/`, menuitem);
  // }

  getPaymentSettings(){
    return this.httpClient.get('/dashboard/get_payment_settings/');

  }
  savePaymentSettings(data){
    return this.httpClient.post('/dashboard/post_payment_settings/', data);
  }

  getMultipleStudentPaymentOption(){
    return this.httpClient.get('/dashboard/get_multiple_student_purchase_status/')
  }
  getDatabaseRows(){
    return this.httpClient.get('/dashboard/database_clear_scripts/');
  }
  DeleteDatabaseRows(data){
    return this.httpClient.post('/dashboard/database_clear_scripts/', data);
  }

  Postwebappsettings(data){
    return this.httpClient.post('/dashboard/webappsettings/', data);
  }
  Getwebappsettings(){
    return this.httpClient.get('/dashboard/getwebappsettings/');
  }
  Getwebappversion(){
    return this.httpClient.get('/dashboard/getactive_webapp_version/',{params:{"type":"active"}});
  }
}
